import { put, select, take } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { selectDraft } from 'modules/Taps/components/NDFL3Light/selectors';
import { updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import { UPDATE_DRAFT_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { STEP_DEDUCTION_FORM } from '../constants';

export function* submitDeductionsSaga({ payload: { getNextStep } }) {
  const draft = yield select(selectDraft);
  const formData = yield select(getFormValues(STEP_DEDUCTION_FORM));
  const fieldKey = ['payload', 'investmentTaxDeduction'];
  const investmentTaxDeduction = formData.getIn(fieldKey);

  yield put(
    updateDraft({
      draft: draft
        .set('currentFormId', 'submit')
        .setIn(['payload', 'deductionSelector', 'investmentDeduction'], true)
        .setIn(fieldKey, investmentTaxDeduction),
    }),
  );
  yield take(UPDATE_DRAFT_SUCCESS);
  yield put(push({ query: { step: getNextStep() } }, { persistQuery: true }));
}
